import Layout from '../../internal/Layout.vue'
import page from './workshops.vue'

const WorkshopsRoutes = {
  component: Layout,
  children: [
    {
      name: 'workshops',
      path: '/',
      component: page,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default WorkshopsRoutes
